import {Api} from "../_helpers/api";
import {to_url} from "../_helpers/utils";
declare const fetch;

const CommonRepository = {
    getStates: () => {
        return fetch(to_url(Api.apiBaseUrl, 'states'), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(response => {
            return response.json();
        });
    },
    getCities: (state: String) => {
        return fetch(to_url(Api.apiBaseUrl, 'cities', state), {
            credentials: "same-origin",
            headers: {
                "Accept": "application/json"
            },
        }).then(response => {
            return response.json();
        });
    }
};

export default CommonRepository;


// WEBPACK FOOTER //
// ./app/client/_repositories/commonRepository.ts